<template>
    <rkm-area
        title="Procedimentos obrigatórios"
        type="fieldset"
    >
        <rkm-form ref="Form">
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="procedimentosPrimarios"
                        :validations="validations.procedimento"
                        label="Procedimento"
                        show-default-option
                        text-field="descricao"
                        v-model="model.procedimentoCodigo"
                        value-field="codigo"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(add)"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            hide-filters
            :items="data.model.procedimentosPrimarios"
            :fields="fields"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :disabled="!!item.hasVinculos"
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </rkm-area>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                procedimento: { required: true }
            }
        },
        procedimentosPrimarios() {

            return this.data.form.procedimentosPrimarios.filter(procedimento =>
                !this.data.model.procedimentosPrimarios.find(p => p.procedimentoCodigo === procedimento.codigo))
        },
    },
    data: () => ({
        model: {
            procedimentoCodigo: null,
        },
        fields: [
            { key: 'procedimentoDescricao', label: 'Procedimento', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' }
        ]
    }),
    methods: {
        add() {

            const data = this.clone(this.model)

            data.procedimentoDescricao = this.data.form.procedimentosPrimarios
                .find(p => p.codigo === data.procedimentoCodigo).descricao

            this.data.model.procedimentosPrimarios.push(data)

            this.resetForm()
        },
        resetForm() {

            this.model.procedimentoCodigo = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        handleDestroy(procedimentoPrimario) {

            const destroy = async () => {

                this.data.model.procedimentosPrimarios
                    .splice(this.data.model.procedimentosPrimarios.indexOf(procedimentoPrimario), 1)
            }

            this.showDeleteConfirmation('Deseja realmente excluir o procedimento primário?', destroy)
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true }
    }
}
</script>